import { render, staticRenderFns } from "./PriceHistoryTable.vue?vue&type=template&id=f51106c2&"
import script from "./PriceHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PriceHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports